import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

let originPush=Router.prototype.push;
let originReplace=Router.prototype.replace;

Router.prototype.push=function (location,resolve,reject){
  if(resolve && reject){
    originPush.call(this,location,resolve,reject)
  }else {
    originPush.call(this,location,()=>{},()=>{})
  }
}
Router.prototype.replace=function (location,resolve,reject){
  if(resolve && reject){
    originReplace.call(this,location,resolve,reject)
  }else {
    originReplace.call(this,location,()=>{},()=>{})
  }
}
const router= new Router({
  routes: [
    {
      path:'/',
      component: (resolve) => require(['@/pages/main'], resolve),
    },
    {
      path:'/boss',
      component:(resolve) => require(['@/pages/boss'], resolve),
    },
    {
      path:'/recruit',
      component: (resolve) => require(['@/pages/recruit'], resolve),
      name:'recruit',
    },
    {
      path:'/account',
      component:(resolve) => require(['@/pages/recruit/thirdRecruit'], resolve),
    },
    {
      path:'/sale',
      component:(resolve) => require(['@/pages/recruit/thirdRecruit'], resolve),
    },
    {
      path:'/food',
      component:(resolve) => require(['@/pages/recruit/thirdRecruit'], resolve),
    },
    {
      path:'/product',
      component:(resolve) => require(['@/pages/recruit/thirdRecruit'], resolve),
    },
    {
      path:'/tec',
      component:(resolve) => require(['@/pages/recruit/thirdRecruit'], resolve),
    },
    {
      path:'/synthesis',
      component:(resolve) => require(['@/pages/recruit/thirdRecruit'], resolve),
    },
    {
      path:'/goodinfo',
      component:(resolve) => require(['@/pages/goodinfo'], resolve),
    },
    {
      path:'/partner',
      component:(resolve) => require(['@/pages/partner'], resolve),
    },
    {
      path:'/service',
      component:(resolve) => require(['@/pages/service'], resolve),
    },
    {
      path:'/develop',
      component:(resolve) => require(['@/pages/develop'], resolve),
    },
    {
      path:'/saleinfo',
      component:(resolve) => require(['@/pages/saleinfo'], resolve),
    },
    {
      path:'/news',
      component:(resolve) => require(['@/pages/news'], resolve),
    },
    {
      path:'/ytnyj',
      component:(resolve) => require(['@/pages/news/ytnyj'], resolve),
    },
    {
      path:'/fivefloorhard',
      component:(resolve) => require(['@/pages/news/fivefloorhard'], resolve),
    },
    {
      path:'/hard',
      component:(resolve) => require(['@/pages/news/hard'], resolve),
    },
    {
      path:'/newsyear',
      component:(resolve) => require(['@/pages/news/newsyear'], resolve),
    },
    {
      path:'/yearparty',
      component:(resolve) => require(['@/pages/news/yearparty'], resolve),
    },
    {
      path:'/cq',
      component:(resolve) => require(['@/pages/news/cq'], resolve),
    },
    {
      path:'/newslist',
      component:(resolve) => require(['@/pages/news/newslist'], resolve),
    },
    {
      path:'/fried',
      component:(resolve) => require(['@/pages/goodinfo/fried'], resolve),
    },
    {
      path:'/charcoal',
      component:(resolve) => require(['@/pages/goodinfo/charcoal'], resolve),
    },
    {
      path:'/steam',
      component:(resolve) => require(['@/pages/goodinfo/steam'], resolve),
    },
    {
      path:'/coated',
      component:(resolve) => require(['@/pages/goodinfo/coated'], resolve),
    },
    {
      path:'/rawmarinade',
      component:(resolve) => require(['@/pages/goodinfo/rawmarinade'], resolve),
    },
    {
      path:'/raw',
      component:(resolve) => require(['@/pages/goodinfo/raw'], resolve),
    },
    {
      path:'/chinese',
      component:(resolve) => require(['@/pages/goodinfo/chinesefood'], resolve),
    },
    {
      path:'/vegetable',
      component:(resolve) => require(['@/pages/goodinfo/vegetable'], resolve),
    },
    {
      path:'/organization',
      component:(resolve) => require(['@/pages/organization'], resolve),
    },
  ],
  mode:'history',
  scrollBehavior(to,from,position){
    return{x:0,y:0}
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js